import { Link } from "react-router-dom";

export const Logo = ({ testId = "logo" }) => (
  <Link to="/" data-testid={testId} className="group flex items-center" aria-label="Foodie Crave home">
    <img
      src="/logo.png"
      alt="Foodie Crave"
      className="h-9 w-auto transition-transform duration-500 group-hover:scale-[1.03] md:h-10"
    />
  </Link>
);
